<mat-card fxLayoutGap class="p-3 h-100 w-100">
  <div *ngIf="title" class="fw-semibold fs-4 mb-2">{{title}}</div>
  <ng-content></ng-content>
</mat-card>
